import { render } from "./App.vue?vue&type=template&id=da0d427c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=da0d427c&lang=css"

import exportComponent from "/mnt/dados/Projects/uparte_dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__